enum EnumPosDeviceType {
	NettoCheck = 1,
	NettoCash = 2,
	Bank = 3,
	ATM = 4,
	Shop = 5,
	MobilStore = 6,
	PaymentSystem = 7,
	RunPayMini = 8,
	RunPayXL = 9,
	RunPayWeb = 10
}
export default EnumPosDeviceType



// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/IServices/Enums/EnumPosDeviceType.ts